import Image from 'next/image';
import Link from 'next/link';
import type { FC } from 'react';

import { AnimatedButton } from '@/components/Landing/AnimatedButton';
import Text from '@/components/Text';

import type { CaseStudyListItem } from './caseStudies';

const CaseStudyCard: FC<CaseStudyListItem> = ({
  href,
  companyName,
  tagline,
  industry,
  logo,
  coverImage,
}) => {
  return (
    <div className="group/caseStudyCard flex w-full flex-col gap-4">
      <div className="relative aspect-video w-full overflow-hidden rounded-xl">
        <Image
          alt={coverImage.alt}
          src={coverImage.src}
          width={coverImage.width}
          height={coverImage.height}
          className="h-full w-full object-cover object-center"
        />
        <div className="absolute left-0 top-0 h-full w-full bg-jb-primary-600/80 transition-colors group-hover/caseStudyCard:bg-jb-primary-600/70" />
        <Image
          alt={companyName}
          src={logo}
          className="absolute left-1/2 top-1/2 max-w-xs -translate-x-1/2 -translate-y-1/2 transition-transform group-hover/caseStudyCard:scale-0"
        />
        <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 scale-0 transition-transform group-hover/caseStudyCard:scale-100">
          <Link href={href}>
            <AnimatedButton
              tabIndex={-1}
              label="Read case study"
              icon="material-symbols:arrow-back"
            />
          </Link>
        </div>
      </div>
      <div className="flex flex-col gap-3">
        <Text variant="h3" className="text-jb-neutral-100">
          {companyName}
        </Text>
        <Text variant="body-caption" className="text-jb-neutral-600">
          {industry}
        </Text>
        <Text className="text-jb-neutral-500">{tagline}</Text>
      </div>
    </div>
  );
};

export default CaseStudyCard;
